/**
 *  数据去抖
 */
export function debounceUtils (func, delay) {
    let timer
    return function (...args) {
        if (timer) {
            clearTimeout(timer)
        }
        timer = setTimeout(() => {
            func.apply(this, args)
        }, delay)
    }
}
/**
 *  数据截流
 */
export function throttle (func, delay) {
    let last = 0
    return function () {
        var curr = +new Date()
        if (curr - last > delay) {
            func.apply(this, arguments)
            last = curr
        }
    }
}

export class Scheduler {
    constructor(max = 3) {
        this.awaitArr = []
        this.count = 0
        this.max = max
    }
    async add (promise) {
        if (this.count < this.max) {
            await new Promise(resolve => this.awaitArr.push(resolve))
        }
        this.count++
        const res = await promise()
        this.count--
        this.awaitArr.length && this.awaitArr.shift()()
        return res
    }
}



// 树转数组树
function treeTolistTree (arr) {
    var res = [];
    !(function fn (arr) {
        arr.forEach(function (item, index) {
            res.push(item);
            if (item.children && item.children.length > 0) {
                fn(item.children);
            }
        });
    })(arr);
    return res;
}

//添加按钮权限
export function addBtnPermission (treelist, to, next) {
    const menuList = treeTolistTree(treelist);
    const path = to.path;
    let btnPermission = [];
    menuList.forEach(({ tbPath, children }) => {
        if (path === tbPath) {
            btnPermission = btnPermission.concat(children.filter(i => i.tbType === 3) || []);
        }
    });
    to.meta["btnPermission"] = btnPermission;
    next && next();
}

export function getAverageValueFuc (yValue) {
    let value = yValue;
    if (value > 30 && value < 200) {
        //获取数组最后一位 值
        if (this.averageHeartArray.length === 0) {
            this.averageHeartArray.push(value)
            return;
        }
        let lastValue = this.averageHeartArray[this.averageHeartArray.length - 1];
        //如果最后一位 与当前值相差45bpm  则数组清空 从新开始计算
        if (Math.abs(value - lastValue) > 45) {
            this.averageHeartArray = []
        }
        this.averageHeartArray.push(value)
        //当采集数据满3s的时候 导入计算
        if (this.averageHeartArray.length === 12) {
            this.averageValue = Math.floor(this.averageHeartArray.reduce((sum, i) => sum += i, 0) / this.averageHeartArray.length)
            this.totalAverageValue = this.averageValue
            if (this.valueSaveArray.length == 0) {
                //将平均值放入数组
                this.valueSaveArray.push(this.averageValue)
            } else {
                //获取数组最后一位 值
                let lastValue2 = this.valueSaveArray[this.valueSaveArray.length - 1];
                //如果最后一位 与当前值相差45bpm  则丢掉 从新开始计算
                if (Math.abs(lastValue2 - this.averageValue) <= 45) {
                    this.valueSaveArray.push(this.averageValue)
                    this.averageValue = Math.floor(this.valueSaveArray.reduce((sum, i) => sum += i, 0) / this.valueSaveArray.length)
                }
            }
            this.totalValueSaveArray.push(this.totalAverageValue)
            if (this.totalValueSaveArray.length > 1) {
                //将平均值放入数组
                this.totalAverageValue = Math.floor(this.totalValueSaveArray.reduce((sum, i) => sum += i, 0) / this.totalValueSaveArray.length)
            }
            this.averageHeartArray = []
        }
    } else {
        this.averageHeartArray = []
    }
}